__turbopack_context__.v({
  "passport_faq_toggle_icon": "PassportTransferFAQ-module-scss-module__EtU4MW__passport_faq_toggle_icon",
  "passport_transfer_faq": "PassportTransferFAQ-module-scss-module__EtU4MW__passport_transfer_faq",
  "passport_transfer_faq__answer": "PassportTransferFAQ-module-scss-module__EtU4MW__passport_transfer_faq__answer",
  "passport_transfer_faq__header": "PassportTransferFAQ-module-scss-module__EtU4MW__passport_transfer_faq__header",
  "passport_transfer_faq__item": "PassportTransferFAQ-module-scss-module__EtU4MW__passport_transfer_faq__item",
  "passport_transfer_faq__question": "PassportTransferFAQ-module-scss-module__EtU4MW__passport_transfer_faq__question",
});
